import noop from 'lodash/noop';
import { loadScript } from '@flowio/browser-helpers';

import features from './features';
import featureKeys from './constants/features';

let didPreloadCheckoutAssets = false;

function preloadCheckoutAssets() {
  if (!didPreloadCheckoutAssets) {
    didPreloadCheckoutAssets = true;
    features.isFeatureEnabled(featureKeys.CHECKOUT_PRELOAD_ASSETS)
      .then((isEnabled) => {
        if (isEnabled) {
          loadScript('//checkout.flow.io/assets/preload.js');
        }
      })
      .catch(noop);
  }
}

module.exports = {
  preloadCheckoutAssets,
};



// WEBPACK FOOTER //
// ./static/js/v0/effects.js